import { render } from "./NewsPublic.vue?vue&type=template&id=535bdbdc&scoped=true"
import script from "./NewsPublic.vue?vue&type=script&lang=js"
export * from "./NewsPublic.vue?vue&type=script&lang=js"

import "./NewsPublic.vue?vue&type=style&index=0&id=535bdbdc&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535bdbdc"]])

export default __exports__